import { Component, OnInit } from '@angular/core';
import { PlanPurchaseService } from '../../services/plan-purchase.service';
import { PlanPurchase } from '../../models/plan-purchase.model';
import { Plan } from "../../../plan";
import { AuthSelectors } from "../../../authentication";
import { Store } from '@ngrx/store';
import { IonIcon } from "@ionic/angular/standalone";
import { SexyModule } from '@qid/sexy';

@Component({
  selector: 'org-plan-badge',
  templateUrl: './org-plan-badge.component.html',
  styleUrls: ['./org-plan-badge.component.scss'],
  imports: [IonIcon, SexyModule],
})
export class OrgPlanBadgeComponent implements OnInit {

  public planPurchases: PlanPurchase[] = [];
  public primaryPlan: Plan = null;
  public activeAccount$ = this.store.select(AuthSelectors.selectActiveAccount);

  constructor(private planPurchaseService: PlanPurchaseService,
    private store: Store
  ) {
  }

  ngOnInit() {
    this.activeAccount$.subscribe(() => {
      this.fetchPlanPurchases();
    });

  }

  async fetchPlanPurchases() {
    this.planPurchases = await this.planPurchaseService.readAll();
    this.setPrimaryPlan();
  }

  setPrimaryPlan() {
    if (!this.planPurchases || this.planPurchases.length < 1) {
      this.primaryPlan = null;
      return;
    }
    this.primaryPlan = this.planPurchases[0].plan;
  }

  openPlanUpgrade() {
    this.planPurchaseService.openPlanUpgrade()
  }
}
